const ShieldIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
);

const ArrowLeftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
    </svg>
);

const SectionIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
    </svg>
);

const PrivacyPolicyPage = ({ attributes, onBack }) => {
    const { privacyPolicyPage = {}, primaryColor = '#ff0037' } = attributes;
    const {
        showHeader = true,
        headerText = 'Legal',
        title = 'Privacy Policy',
        description = 'Privacy Notice - GMF Securities Ltd. Member: Dhaka Stock Exchange (TREC 186). Your trust is the foundation of our relationship.',
        headerIcon = '',
        showBackButton = true,
        backButtonText = 'Back to Home',
        backButtonIcon = '',
        sections = []
    } = privacyPolicyPage;

    const handleBack = () => {
        if (onBack) {
            onBack();
        }
    };

    return (
        <div className="gmf-privacy-page-wrapper">
            <div className="gmf-privacy-page-container">
                {/* Breadcrumb */}
                <div className="gmf-privacy-page-breadcrumb">
                    <span className="gmf-privacy-page-breadcrumb-home" onClick={handleBack}>
                        Home
                    </span>
                    <span className="gmf-privacy-page-breadcrumb-sep">/</span>
                    <span className="gmf-privacy-page-breadcrumb-current">{title || 'Privacy Policy'}</span>
                </div>

                {/* Header Section */}
                {showHeader && (
                    <div className="gmf-privacy-page-header">
                        <div className="gmf-privacy-page-header-icon-wrap" style={{ background: `linear-gradient(135deg, ${primaryColor}22, ${primaryColor}44)` }}>
                            {headerIcon ? (
                                <img src={headerIcon} alt="" className="gmf-privacy-page-header-icon-img" />
                            ) : (
                                <span style={{ color: primaryColor }}><ShieldIcon /></span>
                            )}
                        </div>
                        {headerText && (
                            <span className="gmf-privacy-page-header-label" style={{ color: primaryColor }}>
                                {headerText}
                            </span>
                        )}
                        <h1 className="gmf-privacy-page-title">{title}</h1>
                        {description && (
                            <p className="gmf-privacy-page-description">{description}</p>
                        )}
                    </div>
                )}

                {/* Policy Sections */}
                {sections.length > 0 && (
                    <div className="gmf-privacy-sections">
                        {sections.map((section, index) => (
                            <div key={section.id || index} className="gmf-privacy-section-card">
                                <div className="gmf-privacy-section-header">
                                    <div className="gmf-privacy-section-icon" style={{ color: primaryColor }}>
                                        {section.icon ? (
                                            <img src={section.icon} alt="" className="gmf-privacy-section-icon-img" />
                                        ) : (
                                            <SectionIcon />
                                        )}
                                    </div>
                                    <h2 className="gmf-privacy-section-title">{section.title}</h2>
                                </div>
                                <div className="gmf-privacy-section-content">
                                    {(section.content || '').split('\n').filter((line) => line.length > 0).map((line, li) => (
                                        <p key={li}>{line}</p>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {sections.length === 0 && (
                    <div className="gmf-privacy-empty">
                        <ShieldIcon />
                        <p>No privacy policy sections configured. Please add sections in the settings.</p>
                    </div>
                )}

                {/* Back Button */}
                {showBackButton && (
                    <div className="gmf-privacy-page-back">
                        <button
                            className="gmf-privacy-page-back-btn"
                            onClick={handleBack}
                            style={{ backgroundColor: primaryColor }}
                        >
                            {backButtonIcon && <img src={backButtonIcon} alt="" className="gmf-privacy-page-back-icon" />}
                            <ArrowLeftIcon />
                            {backButtonText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
